if (!customElements.get('sticky-buy-bar')) {
  customElements.define(
    'sticky-buy-bar',
    class StickyBuyBar extends HTMLElement {
      connectedCallback() {
        this.sourcePrice = document.getElementById(this.dataset.sourcePriceId);
        this.sourceButton = document.getElementById(this.dataset.sourceButtonId);
        this.priceNode = this.querySelector('.sticky-buy-bar__price');
        this.button = this.querySelector('[data-sticky-buy-bar-submit]');

        if (!this.sourceButton || !this.button) return;

        this.button.addEventListener('click', () => {
          if (this.sourceButton.disabled) return;
          this.sourceButton.click();
        });

        this.syncPrice();
        this.syncButtonState();

        if (this.sourcePrice) {
          this.priceObserver = new MutationObserver(() => this.syncPrice());
          this.priceObserver.observe(this.sourcePrice, { childList: true, subtree: true, characterData: true });
        }

        this.buttonObserver = new MutationObserver(() => this.syncButtonState());
        this.buttonObserver.observe(this.sourceButton, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true, characterData: true });

        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.onScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        this.priceObserver?.disconnect();
        this.buttonObserver?.disconnect();
      }

      syncPrice() {
        if (this.sourcePrice && this.priceNode) {
          this.priceNode.innerHTML = this.sourcePrice.innerHTML;
        }
      }

      syncButtonState() {
        if (!this.sourceButton || !this.button) return;
        this.button.disabled = this.sourceButton.disabled;
        this.button.textContent = this.sourceButton.textContent.trim();
      }

      onScroll() {
        if (this.throttled) return;
        this.throttled = true;
        setTimeout(() => {
          this.throttled = false;
        }, 100);
        if (!this.sourceButton) return;
        /* Proposal 2026-10-28: show the bar whenever the real button is off screen (above OR below),
           once the visitor has scrolled past the first screen of photos. Before a size is chosen the
           real button says "Velg størrelse" and the bar mirrors it; a tap scrolls to the size row
           (assets/kardima-size-select.js). */
        const rect = this.sourceButton.getBoundingClientRect();
        const offScreen = rect.bottom < 0 || rect.top > window.innerHeight;
        const consentOpen = (() => {
          const b = document.getElementById('KardimaCookieBanner');
          return !!b && !b.hidden;
        })();
        this.classList.toggle('sticky-buy-bar--visible', offScreen && window.scrollY > 300 && !consentOpen);
      }
    }
  );
}
